import { subwayColor, subwayName, subwayStatus } from '../config/subwayConfig'

export default {
  // 画地铁线路地铁站
  drawSubway(currentMap) {
    // 三期
    let that = this;
    that.$axios
      .get(that.$url_prefix + "getSubwayAndStation")
      .then(function (res) {
        console.log("地铁线和地铁站", res);
        let lineList = res.data.subway;
        let stationList = res.data.station;
        for (let i = 0; i < lineList.length; i++) {
          let loc = lineList[i];

          //地铁线路
          let dots = loc.dots.split("-").map((x) => {
            return x.split("|");
          });
          let paths = [];
          if (loc.name === "19号线") {
            paths.push({
              style: "solid",
              path: dots.slice(0, 242),
            });
            paths.push({
              style: "dashed",
              path: dots.slice(242),
            });
          } else if (loc.name === "5号线") {
            paths.push({
              style: "solid",
              path: dots.slice(0, 391),
            });
            paths.push({
              style: "dashed",
              path: dots.slice(391),
            });
          } else if (loc.name === "6号线支线") {
            paths.push({
              style: "dashed",
              path: dots.slice(0, 2),
            });
            paths.push({
              style: "solid",
              path: dots.slice(2),
            });
          } else if (loc.name === "12号线") {
            paths.push({
              style: "dashed",
              path: dots.slice(0, 2),
            });
            paths.push({
              style: "solid",
              path: dots.slice(2, 37),
            });
            paths.push({
              style: "dashed",
              path: dots.slice(37),
            });
          } else {
            paths = [
              {
                style: subwayStatus[loc.name],
                path: dots,
              },
            ];
          }
          for (let p = 0; p < paths.length; p++) {
            let polyline = new AMap.Polyline({
              path: paths[p].path,
              strokeWeight: 16, // 线条宽度，默认为 1
              strokeDasharray: [12, 6],
              strokeStyle: paths[p].style, //线条样式
              strokeColor: subwayColor[loc.name], // 线条颜色
              strokeOpacity: 1,
              lineJoin: "round", // 折线拐点连接处样式
            });
            currentMap.add(polyline);
          }

          // 线路名,10号线特殊
          let name_pos = loc.mark.split("-");
          let name_color = "#000000";
          if (loc.name === "1号线") {
            name_color = "#ffffff";
          }
          for (let k = 0; k < name_pos.length; k++) {
            let text = new AMap.Text({
              zIndex: 55,
              text: subwayName[loc.name],
              textAlign: "center",
              verticalAlign: "middle",
              style: {
                // 'padding': '.20rem .50rem',
                // 'border-radius': '.25rem',
                "background-color": subwayColor[loc.name],
                "border-width": 0,
                // 'margin-top': '1rem',
                "font-size": "20px",
                "line-height": "20px",
                color: name_color,
              },
              position: name_pos[k].split("|"),
            });
            text.setMap(currentMap);
          }
        }
        for (let i = 0; i < stationList.length; i++) {
          let loc = stationList[i];

          //地铁站图标，分换乘和非换乘的
          // let fillColor = '#20B2AA'
          // if (loc.subway_station.indexOf('|') > -1) {
          //   fillColor = '#ffffff'
          // }
          // let circleMarker = new AMap.CircleMarker({
          //   center: loc.lnglat.split('-')[0].split('|'),
          //   radius: 8,
          //   zIndex: 111,
          //   // strokeColor: 'orange',
          //   strokeWeight: 0,
          //   strokeOpacity: 0,
          //   fillColor: fillColor,
          //   fillOpacity: 1,
          //   // bubble: true,
          //   // cursor: 'pointer',
          //   // clickable: true
          // })
          // circleMarker.setMap(currentMap)
          let markerContent = `
              <div class="stationIcon1" style="background-color:${
                subwayColor[loc.subway_station]
              };">
                <div></div>
              </div>
              `;
          if (loc.subway_station.indexOf("|") > -1) {
            markerContent = `
              <div class="stationIcon2">
                <img src="../../static/images/change.png" />
              </div>
              `;
          } else if (loc.stage == "四期") {
            markerContent = `
              <div class="stationIcon1" style="background-color: ${
                subwayColor[loc.subway_station]
              };">
                <div></div>
              </div>
              `;
          }
          var marker = new AMap.Marker({
            zIndex: 168,
            position: loc.lnglat.split("-")[0].split("|"),
            content: markerContent,
            offset: new AMap.Pixel(-10, -10),
          });
          marker.setMap(currentMap);

          //站点名
          let text = new AMap.Text({
            text: loc.location_name,
            textAlign: "center",
            verticalAlign: "middle",
            style: {
              zIndex: 102,
              // 'padding': '.20rem .50rem',
              // 'border-radius': '.25rem',
              // 'background-color': '#a3ff59',
              "background-color": "#ffffff",
              "border-width": 0,
              "margin-top": "1rem",
              "font-size": "10px",
              "line-height": "10px",
              // 'color': '#ffffff',
              color: "#000000",
            },
            position: loc.lnglat.split("-")[0].split("|"),
          });
          text.setMap(currentMap);
        }

        // 画杭州区域
        // that.drawCity(currentMap)
      })
      .catch(function (res) {
        console.log("查询地铁线路失败", res);
      });
  },

  drawSubway4(currentMap) {
    // 四期
    let that = this;
    that.$axios
      .get(that.$url_prefix + "getSubway4")
      .then(function (res) {
        console.log("4期地铁线", res);
        let lineList = res.data.data;
        // let stationList = [];
        for (let i = 0; i < lineList.length; i++) {
          let loc = lineList[i];
          // stationList = stationList.concat(JSON.parse(loc.station))

          //地铁线路
          let dots = loc.dots.split("-").map((x) => {
            return x.split("|");
          });
          let polyline = new AMap.Polyline({
            path: dots,
            strokeWeight: 16, // 线条宽度，默认为 1
            strokeStyle: "dashed", //线条样式
            strokeDasharray: [8, 16],
            strokeColor: subwayColor[loc.name], // 线条颜色
            strokeOpacity: 1,
            lineJoin: "round", // 折线拐点连接处样式
          });
          currentMap.add(polyline);

          // 线路名,10号线特殊
          if (!loc.mark) {
            console.log("no mark", loc.name);
          }
          let name_pos = loc.mark.split("-");
          let name_color = "#000";

          for (let k = 0; k < name_pos.length; k++) {
            let text = new AMap.Text({
              zIndex: 55,
              text: subwayName[loc.name],
              textAlign: "center",
              verticalAlign: "middle",
              style: {
                // 'padding': '.20rem .50rem',
                // 'border-radius': '.25rem',
                "background-color": subwayColor[loc.name],
                "border-width": 0,
                // 'margin-top': '1rem',
                "font-size": "20px",
                "line-height": "20px",
                color: name_color,
              },
              position: name_pos[k].split("|"),
            });
            text.setMap(currentMap);
          }
        }
        // for (let i = 0; i < stationList.length; i++) {
        //   let loc = stationList[i]

        //   let markerContent = `
        //       <div class="stationIcon1" style="background-color: #000000;">
        //         <div></div>
        //       </div>
        //       `;
        //   var marker = new AMap.Marker({
        //     zIndex: 160,
        //     position: loc.position,
        //     content: markerContent,
        //     offset: new AMap.Pixel(-10, -10)
        //   });
        //   marker.setMap(currentMap);
        // }

        // 画杭州区域
        // that.drawCity(currentMap)
      })
      .catch(function (res) {
        console.log("查询地铁线路失败", res);
      });
  },

  drawOneSubway() {
    let that = this;
    let currentMap = that.currentMap;
    that.$axios
      .get(that.$url_prefix + "drawOneSubway", {
        params: {
          line: that.curline,
        },
      })
      .then((res) => {
        console.log("res", res);
        currentMap.clearMap();
        let resData = res.data.data;
        let lineList = resData.subway;
        let stationList = resData.station;
        let realList = resData.realList;
        let companys = resData.companys;
        let markets = resData.markets;
        let subColor = "#ec0e37";
        that.drawAreaNew(currentMap, true);

        // 线路
        for (let i = 0; i < lineList.length; i++) {
          let loc = lineList[i];

          //地铁线路
          let dots = loc.dots.split("-").map((x) => {
            return x.split("|");
          });
          loc.name = loc.name.replace("支线", "").replace("延长", "");
          let polyline = new AMap.Polyline({
            path: dots,
            strokeWeight: 8, // 线条宽度，默认为 1
            strokeStyle: "solid", //线条样式
            strokeColor: subColor, // 线条颜色
            strokeOpacity: 1,
            lineJoin: "round", // 折线拐点连接处样式
          });
          currentMap.add(polyline);

          // 线路名,10号线特殊
          let name_pos = loc.mark.split("-");
          let name_color = "#000000";
          if (loc.name === "1号线") {
            name_color = "#ffffff";
          }
          for (let k = 0; k < name_pos.length; k++) {
            let text = new AMap.Text({
              zIndex: 55,
              text: subwayName[loc.name] || parseInt(loc.name),
              textAlign: "center",
              verticalAlign: "middle",
              style: {
                // 'padding': '.20rem .50rem',
                // 'border-radius': '.25rem',
                "background-color": subColor,
                "border-width": 0,
                // 'margin-top': '1rem',
                "font-size": "10px",
                "line-height": "10px",
                color: name_color,
              },
              position: name_pos[k].split("|"),
            });
            text.setMap(currentMap);
          }
        }

        // 站点
        let theSta;
        for (let i = 0; i < stationList.length; i++) {
          let loc = stationList[i];
          loc.subway_station = loc.subway_station
            .replace("支线", "")
            .replace("延长", "");
          let markerContent = `
              <div class="stationIcon1" style="background-color:${subColor};">
                <div></div>
              </div>
              `;
          if (loc.subway_station.indexOf("|") > -1) {
            markerContent = `
              <div class="stationIcon2">
                <img src="../../static/images/change.png" />
              </div>
              `;
          }
          var marker = new AMap.Marker({
            zIndex: 168,
            position: loc.lnglat.split("-")[0].split("|"),
            content: markerContent,
            offset: new AMap.Pixel(-10, -10),
          });
          marker.setMap(currentMap);

          if (!theSta) {
            theSta = loc.lnglat.split("-")[0].split("|");
          }

          //站点名
          let text = new AMap.Text({
            text: loc.location_name,
            textAlign: "center",
            verticalAlign: "middle",
            style: {
              zIndex: 102,
              // 'padding': '.20rem .50rem',
              // 'border-radius': '.25rem',
              // 'background-color': '#a3ff59',
              "background-color": "#ffffff",
              "border-width": 0,
              "margin-top": "1rem",
              "font-size": "10px",
              "line-height": "10px",
              // 'color': '#ffffff',
              color: "#000000",
            },
            position: loc.lnglat.split("-")[0].split("|"),
          });
          text.setMap(currentMap);
        }
        if (theSta) {
          that.center = theSta;
        }

        // 楼盘
        let mapData = {};
        for (let i = 0; i < realList.length; i++) {
          let loc = realList[i];
          let markerContent = "";
          let piece = loc.piece;
          if (!piece) {
            console.log("loc");
            continue;
          }
          let judge = "#fde101"; // 地铁盘
          let expect = "";
          piece.forEach((x) => {
            if (x.price1) {
              x.price = x.price1;
            }
          });
          piece.sort((a, b) => {
            return a.price - b.price;
          });
          let priceLen = piece.length;
          if (priceLen === 0) {
            markerContent = `
            <div class="newEstate">
              <div class="realPrice" style="background-color:${judge}">
                <div>${loc.real_estate_name}</div>
              </div>
              ${expect}
            </div>
            `;
          } else if (priceLen === 1) {
            markerContent = `
            <div class="newEstate">
              <div class="realPrice" style="background-color:${judge}">
                <div>${loc.real_estate_name}</div>
                <div class="realPrice-c">${piece[0].type}${piece[0].price}</div>
              </div>
              ${expect}
            </div>
            `;
          } else if (priceLen === 2) {
            markerContent = `
            <div class="newEstate">
              <div class="realPrice" style="background-color:${judge}">
                <div>${loc.real_estate_name}</div>
                <div class="realPrice-c">${piece[0].type}${piece[0].price}</div>
                <div class="realPrice-c">${piece[1].type}${piece[1].price}</div>
              </div>
              ${expect}
            </div>
            `;
          } else if (priceLen > 2) {
            markerContent = `
            <div class="newEstate">
              <div class="realPrice" style="background-color:${judge}">
                <div>${loc.real_estate_name}</div>
                <div class="realPrice-c">${piece[0].type}${piece[0].price}</div>
                <div class="realPrice-c">${piece[1].type}${piece[1].price}</div>
                <div class="realPrice-c">${piece[2].type}${piece[2].price}</div>
              </div>
              ${expect}
            </div>
            `;
          }

          let realPos = loc.lnglat.split("|");
          let position = realPos;
          // if (loc.move) {
          //   position = loc.move.split('|');
          //   mapData[loc.id] = {
          //     marker: realPos,
          //     line: [realPos, position]
          //   }
          // }
          let nameLen = loc.real_estate_name.length;
          if (nameLen <= 6 && priceLen > 0) {
            nameLen = 6.5;
          }
          let offsetX = -nameLen * 10;
          let offsetY = -(priceLen + 1) * 15;

          let marker = new AMap.Marker({
            real_id: loc.id,
            position: position,
            content: markerContent,
            offset: new AMap.Pixel(offsetX, offsetY),
            draggable: true,
          });
          marker.setMap(currentMap);
        }
        // that.landMarkers = mapData;

        // 企业
        for (let i = 0; i < companys.length; i++) {
          let temp = companys[i];
          let markerContent = `
              <div class="loc2">
                <div>${temp.location_name}</div>
              </div>
              `;

          let marker = new AMap.Marker({
            position: temp.lnglat.split("-")[0].split("|"),
            content: markerContent,
            offset: new AMap.Pixel(-20, -15),
            draggable: true,
          });
          marker.setMap(currentMap);
        }

        // 商场
        for (let i = 0; i < markets.length; i++) {
          let temp = markets[i];
          let markerContent = `
              <div class="loc1">
                <div>${temp.location_name}</div>
              </div>
              `;

          let marker = new AMap.Marker({
            position: temp.lnglat.split("-")[0].split("|"),
            content: markerContent,
            offset: new AMap.Pixel(-20, -15),
            draggable: true,
          });
          marker.setMap(currentMap);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/subway.js